module.exports = __webpack_public_path__ + "img/creme_brulee_klar.e6d10a02.jpg";